export const PRODUCT_TARGET_VALUES = ['Principianti', 'Appassionati', 'Evoluti', 'Avanzati', 'Professionale'];